module.exports = __webpack_public_path__ + "static/media/ui.fbe54b2a.png";